import React, { useState } from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Container,
  IconButton,
  Menu,
  InputBase,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import FacebookIcon from "@mui/icons-material/Facebook";
import { NavLink, useNavigate } from "react-router-dom";
import CartIcon from "./CartIcon";
import Logo from "../images/logo-stc.jpg";
import "./NavBar.css";

const pages = [
  { title: "Начало", url: "/" },
  { title: "Препарати", url: "/preparati-za-solarni-paneli" },
  { title: "Услуги", url: "/uslugi-solarni-paneli" },
  { title: "Заяви оферта", url: "/oferta-na-preparati-za-solarni-paneli" },
  { title: "B2B секция", url: "/b2b" },
  { title: "Контакти", url: "/contacts" },
];

export default function Navigation() {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (!search.trim()) return;
    navigate(`/preparati-za-solarni-paneli?search=${encodeURIComponent(search)}`);
    setSearch("");
    setSearchOpen(false);
  };

  return (
    <AppBar position="sticky" elevation={1} sx={{ background: "#fff" }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          {/* LOGO */}
          <NavLink to="/">
            <img src={Logo} alt="logo" className="logo-style" />
          </NavLink>

          {/* DESKTOP NAV */}
<Box
  component="nav"
  sx={{
    flexGrow: 1,
    display: { xs: "none", md: "flex" },
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "8px",
    ml: 3,
    minWidth: 0,
  }}
>
  {pages.map((page) => (
    <NavLink
      key={page.title}
      to={page.url}
      className={({ isActive }) =>
        isActive ? "active-link" : "myLink"
      }
      end={page.url === "/"}
    >
      {page.title}
    </NavLink>
  ))}
</Box>

          {/* SEARCH ICON / INPUT */}
          <Box component="form" onSubmit={handleSearch} sx={{ mr: 1 }}>
            {searchOpen && (
              <InputBase
                autoFocus
                placeholder="Търсене…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="search-input"
              />
            )}
            <IconButton onClick={() => setSearchOpen(!searchOpen)}>
              <SearchIcon />
            </IconButton>
          </Box>

          {/* SOCIAL + CART */}
          <IconButton href="https://facebook.com/tc.energy.solar.cleaning.solutions" target="_blank">
            <FacebookIcon />
          </IconButton>
          <CartIcon />

          {/* MOBILE MENU */}
          <IconButton
            sx={{ display: { xs: "flex", md: "none" }, ml: 1 }}
            onClick={(e) => setAnchorElNav(e.currentTarget)}
          >
            <MenuIcon />
          </IconButton>

          <Menu
            anchorEl={anchorElNav}
            open={Boolean(anchorElNav)}
            onClose={() => setAnchorElNav(null)}
          >
            {pages.map((page) => (
              <NavLink
                key={page.title}
                to={page.url}
                className="mobile-link"
                onClick={() => setAnchorElNav(null)}
              >
                {page.title}
              </NavLink>
            ))}
          </Menu>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
